import React, { useState } from 'react';
import { Loader2, User as UserIcon, Lock } from 'lucide-react';

const LoginView = ({ onLogin }) => {
  const [oaId, setOaId] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      onLogin(oaId); 
    }, 800);
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md border border-slate-200">
        <div className="text-center mb-8">
           <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4 shadow-lg shadow-blue-900/30">C</div>
           <h1 className="text-2xl font-bold text-slate-800">废钢直通车运营工作台</h1>
           <p className="text-slate-500 text-sm mt-2">OA 统一身份认证</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
           <div>
             <label className="block text-sm font-medium text-slate-700 mb-1.5">OA 账号</label>
             <div className="relative">
               <UserIcon className="absolute left-3 top-2.5 text-slate-400 w-5 h-5" />
               <input type="text" required value={oaId} onChange={(e) => setOaId(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="请输入工号" />
             </div>
           </div>
           <div>
             <label className="block text-sm font-medium text-slate-700 mb-1.5">密码</label>
             <div className="relative">
               <Lock className="absolute left-3 top-2.5 text-slate-400 w-5 h-5" />
               <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="请输入密码" />
             </div>
           </div>
           <button type="submit" disabled={isLoading} className="w-full bg-blue-600 text-white py-2.5 rounded-lg font-medium hover:bg-blue-700 focus:ring-4 focus:ring-blue-200 transition-all flex justify-center items-center">
             {isLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : '登 录'}
           </button>
        </form>
        <div className="mt-6 text-center text-xs text-slate-400">
           &copy; 2026 废钢直通车项目组 | 技术支持: 信息技术部 | v1.1
        </div>
      </div>
    </div>
  );
};

export default LoginView;
